export default {
  logout: "خروج"
}

